import { render, staticRenderFns } from "./v-chat-composer.vue?vue&type=template&id=0f5580b3&scoped=true&"
var script = {}
import style0 from "./v-chat-composer.vue?vue&type=style&index=0&id=0f5580b3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5580b3",
  null
  
)

export default component.exports